import notification from 'modules/notification-manager'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'

import {
  getDependentsEligibleForMedicalBenefits,
  getPersonSelector,
} from 'store/modules/persons/selectors'

import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import { getHealthGroups, isImpersonating, isHixmeAdmin } from 'store/modules/user-session/selectors'
import { addToCart, removeFromCart, tryToggleFavorite } from '../actions'
import {
  getCurrentGroupBundles,
  getCurrentGroupIndex,
  getCurrentGroupProviders,
} from '../selectors'

const isConfirmedProvider = (npi, allBundleProviders) =>
  allBundleProviders.some((provider) => provider.npi === npi)

const mapStateToProps = (state, { carrierNoticeConfig = {}, ...props }) => {
  const bundle = getCurrentGroupBundles(state)[props.bundleId]
  const person = getPersonSelector(state)
  const dependents = getDependentsEligibleForMedicalBenefits(state)

  const currGroupIndx = getCurrentGroupIndex(state)
  const groups = getHealthGroups(state) || []

  const groupState = groups[currGroupIndx]?.StateProvince || ''
  const isNoticeVisible =
    carrierNoticeConfig[bundle.CarrierName] &&
    carrierNoticeConfig[bundle.CarrierName]?.State?.includes(groupState)
  const bundleProviders = bundle.Providers || []
  const providers = getCurrentGroupProviders(state).map((provider) => ({
    ...provider,
    confirmed: isNoticeVisible ? false : isConfirmedProvider(provider.npi, bundleProviders),
  }))
  const coveredPeopleCount = bundle.groupPersons
    ? bundle.groupPersons.length
    : [person, ...dependents].length
  const isProcessing =
    getWaiter(state, `ADD_TO_CART_${props.bundleId}`).isPending ||
    getWaiter(state, `REMOVE_FROM_CART_${props.bundleId}`).isPending

  return {
    bundle,
    coveredPeopleLabel: `Per paycheck (for ${coveredPeopleCount} ${
      coveredPeopleCount !== 1 ? 'people' : 'person'
    })`,
    isProcessing,
    isNoticeVisible,
    ...(isNoticeVisible && { website: carrierNoticeConfig[bundle.CarrierName]?.Website }),
    providers,
    isImpersonated: isImpersonating(state),
    isTestUser: person?.IsTestUser,
    showTotalMonthlyPremium: isHixmeAdmin(state) && isImpersonating(state),
    coveredPeopleCount,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onAddToCart: (bundlePublicKey, qleEnrollmentKey, options) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      const activityLogOptions = {
        reason,
        reasonCategory,
        zendeskTicket,
      }
      dispatch(addToCart(bundlePublicKey, qleEnrollmentKey, activityLogOptions)).catch((error) => {
        dispatch(
          notification.actions.createNotification({
            type: 'error',
            message: `There was an error adding to Cart: ${error.message}`,
          })
        )
      })
    }

    handleActivityLogPopup({
      isImpersonated: options?.isImpersonated,
      isTestUser: options?.isTestUser,
      isActivityLogEnabled: options?.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to add/remove this plan to your benefits?',
      onSubmit: callback,
    })
  },
  onRemoveFromCart: (bundlePublicKey, qleEnrollmentKey, options) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      const activityLogOptions = {
        reason,
        reasonCategory,
        zendeskTicket,
      }
      dispatch(removeFromCart(bundlePublicKey, qleEnrollmentKey, activityLogOptions)).then(
        () => {},
        (error) => {
          dispatch(
            notification.actions.createNotification({
              type: 'error',
              message: `There was an error removing from Cart: ${error.message}`,
            })
          )
        }
      )
    }

    handleActivityLogPopup({
      isImpersonated: options?.isImpersonated,
      isTestUser: options?.isTestUser,
      isActivityLogEnabled: options?.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to add/remove this plan to your benefits?',
      onSubmit: callback,
    })
  },

  onToggleFavorite: (BundlePublicKey) => {
    dispatch(tryToggleFavorite(BundlePublicKey))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
